import { Navigate, Route, Routes } from 'react-router-dom'
import { AppShell } from './components/AppShell'
import { NotFound } from './components/NotFound'
import { SignIn } from './components/SignIn'
import { useAuth } from './hooks/useAuth'
import { AccountView } from './features/account/AccountView'
import { AccountsView } from './features/accounts/AccountsView'
import { LibraryView } from './features/library/LibraryView'
import { ResearchView } from './features/research/ResearchView'

export function App() {
  const { me, loading } = useAuth()

  if (loading) {
    return (
      <div className="boot">
        <div className="ring" />
      </div>
    )
  }

  // Everything behind the shell requires a live session; there is no anonymous view of the app.
  if (!me?.authenticated) return <SignIn />

  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Navigate to="/accounts" replace />} />
        <Route path="/accounts" element={<AccountsView />} />
        <Route path="/accounts/:company" element={<AccountView />} />
        <Route path="/research" element={<ResearchView />} />
        <Route path="/case-studies" element={<LibraryView />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AppShell>
  )
}
